import {Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'

export default function Label({text, fs, fw, color, align, mw, sx, dir}: any) {
  const {t} = useTranslation()
  const store = useSelector((state: RootState) => state.vender)

  return (
    <Typography
      dir={dir || (store.isRtl !== 0 ? 'rtl' : 'ltr')}
      align={align || 'inherit'}
      sx={{
        color: color || '#19224C',
        fontSize: fs || '16px',
        fontWeight: fw || '400',
        textTransform: 'capitalize',
        maxWidth: mw || 'auto',
        ...sx,
      }}
    >
      {t(text)}
    </Typography>
  )
}
